import Vue from 'vue'

function sortBlockByName (a, b) {
  return a.block > b.block ? 1 : -1
}

// function sortRealEstateByName (a, b) {
//   return a.name > b.name ? 1 : -1
// }

// initial state
const state = {
  systemStatus: {},
  systemStatusRaw: {}
}

// getters
const getters = {
  all: state => state.systemStatus,
  allRaw: state => state.systemStatusRaw,
  bySystemRaw: (state, getters) => (sys) => getters.allRaw.filter(system => system.system === sys),
  byStatusRaw: (state, getters) => (status) => getters.allRaw.filter(system => system.status === status),
  allBlocksAndSystems: (state, getters, rootState, rootGetters) => {
    let set = [...new Set(rootGetters['realEstate/blocks'])]
    let systems = []
    set.forEach(block => {
      let sys = []
      getters.allRaw.forEach(system => {
        rootGetters['realEstate/find'](system.realEstateID.toString())
        system.name = rootGetters['realEstate/find'](system.realEstateID.toString()).name
        if (block === rootGetters['realEstate/find'](system.realEstateID.toString()).block) {
          sys.push(system)
        }
      })
      let obj = {
        block: block,
        systems: sys
      }
      if (sys.length > 0) systems.push(obj)
    })
    let allSystems = []
    systems.forEach(sys => {
      sys.systems.forEach(system => {
        allSystems.push(system)
      })
    })
    let obj = {
      block: 'Alla',
      systems: allSystems
    }
    systems.push(obj)
    systems.sort(sortBlockByName)
    return systems
  }
}

// actions
const actions = {

  async fetchSystemStatusRaw ({ commit }) {
    const res = await Vue.axios.get('/api/status/system')

    // const res = {
    //   status: 200,
    //   systems: [
    //     { system: 'Kabona', status: 0, updatedAt: '2020-12-16T20:37:26Z', realEstateID: 2000 },
    //     { system: 'AddView', status: 1, updatedAt: '2020-12-16T20:37:26Z', realEstateID: 2000 },
    //     { system: 'Kabona', status: 1, updatedAt: '2020-12-16T20:37:26Z', realEstateID: 8080 },
    //     { system: 'AddView', status: 1, updatedAt: '2020-12-16T20:37:26Z', realEstateID: 8080 },
    //   ]
    // }

    if (res.status === 200) commit('setSystemStatusRaw', res.data.systems)
  }
}

// mutations
const mutations = {
  setSystemStatusRaw (state, systemStatus) {
    state.systemStatusRaw = systemStatus
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/status.js